import React, { forwardRef } from 'react';

import cn from 'classnames';

import { Icon } from '@shared/ui';

import cls from './DraggableEl.module.css';

interface IDraggableElProps extends React.HTMLAttributes<HTMLSpanElement> {
    disabled?: boolean;
}
export const DraggableEl = forwardRef<HTMLSpanElement, IDraggableElProps>(
    ({ className, ...rest }, ref) => (
        <span ref={ref} className={cn(cls.DraggableEl, className)} {...rest}>
            <Icon iconName="draggableHandle" fill={rest.disabled ? '#81899880' : '#818998'} />
        </span>
    )
);

DraggableEl.displayName = 'DraggableEl';
